

































































































































































































































import Vue from 'vue';
import axios from 'axios';
import AppHeader from '@/components/AppHeader.vue';
import userService from '@/services/hub/user';
import { debounce } from 'lodash';

export default Vue.extend({
  name: 'ViewLogs',
  components: {
    AppHeader,
  },
  data() {
    return {
      logs: [],
      actionType: null,
      statusType: null,
      videoHash: null,
      startDate: null,
      endDate: null,
      actionTypes: [
        { text: this.$t('Creation'), value: 'Creation' },
        { text: this.$t('Modification'), value: 'Modification' },
        { text: this.$t('Deletion'), value: 'Deletion' },
        { text: this.$t('Purchase'), value: 'Purchase' },
        { text: this.$t('Credits spent'), value: 'Credits spent' },
      ],
      statusTypes: [
        { text: this.$t('Success'), value: 'Success' },
        { text: this.$t('Error'), value: 'Error' },
      ],
      headers: [
        { text: this.$t('Action performed'), value: 'action', width: '150px' },
        { text: this.$t('Action status'), value: 'status', width: '150px' },
        { text: this.$t('Action description'), value: 'description' },
        { text: this.$t('Date'), value: 'timestamp' },
      ],
      page: 1,
      itemsPerPage: 5,
      pageCount: 0,
      planOdId: 0,
      id_customer: 0,
      userToken: '' as any,
      customerPlansId: 0,
      startDateMenu: false,
      endDateMenu: false,
      debouncedFetchLogs: debounce(function (this: any) {
        this.fetchLogs();
      }, 300),
    };
  },
  watch: {
    actionType() {
      this.page = 1;
      this.fetchLogs();
    },
    statusType() {
      this.page = 1;
      this.fetchLogs();
    },
    startDate() {
      this.page = 1;
      this.fetchLogs();
    },
    endDate() {
      this.page = 1;
      this.fetchLogs();
    },
    videoHash() {
      this.page = 1;
      this.debouncedFetchLogs();
    },
  },
  async mounted() {
    await this.userInformation();
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const customerObjectId = JSON.parse(userInfo);
        this.customerPlansId = customerObjectId.user.plan_id;
        this.userToken = customerObjectId.token;
        await this.getPlanOd(this.customerPlansId);
        await this.getCustomerPlan(this.planOdId);
        await this.fetchLogs();
      }
    },
    async getPlanOd(customerPlansId: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${customerPlansId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.id_customer = response.data.data.id_customers;
    },
    async fetchLogs() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/logs/${this.id_customer}`, {
          params: {
            page: this.page,
            limit: this.itemsPerPage,
            actionType: this.actionType,
            statusType: this.statusType,
            startDate: this.startDate,
            endDate: this.endDate,
            videoHash: this.videoHash,
          },
        });

        this.logs = response.data.logs;
        this.pageCount = response.data.pageCount;
      } catch (error) {
        console.error('Erro ao buscar logs:', error);
      }
    },
    formatDate(date: any) {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
      };
      return new Date(date).toLocaleString('pt-BR', options);
    },
    goToFirstPage() {
      if (this.page > 1) {
        this.page = 1;
        this.fetchLogs();
      }
    },
    goToPreviousPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.fetchLogs();
      }
    },
    goToNextPage() {
      if (this.page < this.pageCount) {
        this.page += 1;
        this.fetchLogs();
      }
    },
    goToLastPage() {
      if (this.page < this.pageCount) {
        this.page = this.pageCount;
        this.fetchLogs();
      }
    },
  },
});
